
import { Form, Checkbox } from 'antd';
import services from '../../services';

const FormItem = Form.Item;

import React, { Component } from 'react'

class EvalExtItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            extendEval: [],
            extendValue: []
        }
    }

    componentDidMount() {
        services.items.findExtendEvalType()
            .then((res) => {
                let extendEval = res.map((item) => item.codeName)
                let extendValue = res.map(item => item.codeValue)
                this.setState({
                    extendEval,
                    extendValue
                })

            });

    }

    render() {
        let { actionDisable, value, handleChange } = this.props;
        let extendEval = this.state.extendEval;
        let extendValue = this.state.extendValue;
        return (
            <FormItem label="扩展评价项目" >
                <div style={{display: 'flex'}}>
                {
                    extendEval.map((item, index) => {
                        return <div key={'extendEval' + index}>
                        <Checkbox
                        disabled={actionDisable}
                        checked={value != null && value.indexOf(extendValue[index] + "on" || "") !== -1 ? true : false}
                        onChange={(event) => {
                            const evalExtItem = event.target.checked ? extendValue[index] + "on" : extendValue[index] + "off";
                            handleChange({ evalExtItem });
                        }}></Checkbox>{extendEval[index] + " "}
                        </div>

                    })
                }
                </div>
            </FormItem>
        )
    }
}

export default EvalExtItem;
